/* eslint-disable eqeqeq */
/* eslint-disable no-console */
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Popover } from "antd";
import { useNavigate } from "react-router-dom";
import CloseIcon from "../../../Common/Svgs/CloseIcon";
import NotificationIcon, {
  TimeoffNotificationIcon,
  TimeoffNotificationIconWithRedDot,
} from "../../../Common/Svgs/NotificationIcon";
// import NotificationItem from "./NotificationItem";
import {
  getTimeoffNotifications,
  updateTimeoffNotifications,
} from "../../../Redux/APIs/homeAPI";
import { updateHome } from "../../../Redux/Slices/home.slice";
import { client } from "../../../Utils/axiosClient";
import CustomTooltip from "../../Components/CustomTooltip";
import TimeoffCard from "../../../Modules/Users/phase3/Driver/Calendar/Common/TimeoffCard";
import { updateUsers } from "../../../Redux/Slices/users.slice";
import { LOCATION_TYPE } from "../../../Modules/Location/Data";
import FilterItem from "../../Components/FilterItem";
// import { updateUsers } from "../../../Redux/Slices/users.slice";

const EmptyState = () => {
  return (
    <div className="flex justify-center w-full h-[300px] px-2">
      <div className="mt-[100px] flex flex-col items-center gap-y-2">
        <NotificationIcon className="fill-light-grey stroke-light-grey" />

        <p className="text-sm font-semibold font-aileron text-dark-gray">
          No new notifications
        </p>
      </div>
    </div>
  );
};

const TimeoffNotificationPopup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    timeoffNotificationPopupVisible,
    timeoffShowNotificationDot,
    timeoffNotifications,
  } = useSelector((state) => state.home);

  const { allLocations } = useSelector((state) => state.locations);
  const { userDetails } = useSelector((state) => state.loggedInUser);

  const [selectedHubs, setSelectedHubs] = useState([]);

  const hubs = useMemo(() => {
    const result = allLocations
      .filter(
        (item) =>
          item.type === LOCATION_TYPE.HUB_STATION &&
          userDetails.hubs.includes(item.id),
      )
      .map((location) => ({
        id: location.id,
        value: location.name,
      }));
    return result;
  }, [allLocations, userDetails.hubs]);

  const onSelect = (key, value) => {
    if (selectedHubs.includes(value)) {
      const newFilters = selectedHubs.filter((item) => item !== value);
      setSelectedHubs(newFilters);
    } else {
      setSelectedHubs([...selectedHubs, value]);
    }
  };

  const handleClearAll = async () => {
    try {
      const response = await client.post(
        `${process.env.REACT_APP_API_URL}/notifications/clear-timeoff-notifications`,
      );

      if (response.data.action == 0) {
        dispatch(
          updateHome({
            key: "cannotClearTimeoffNotificationModal",
            value: true,
          }),
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(
        updateHome({
          key: "timeoffNotificationPopupVisible",
          value: false,
        }),
      );
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(getTimeoffNotifications({ selectedHubs }));
    }, 10000);

    return () => clearInterval(interval);
  }, [dispatch, selectedHubs]);

  useEffect(() => {
    if (timeoffNotificationPopupVisible) {
      dispatch(getTimeoffNotifications({ selectedHubs }));
      dispatch(updateTimeoffNotifications());
    }
  }, [dispatch, timeoffNotificationPopupVisible, selectedHubs]);

  const handleApprove = async (item) => {
    const trips = item.tripsCount || 0;
    const sessions = item.sessionsCount || 0;

    const hasConflict = trips > 0 || sessions > 0;

    if (hasConflict) {
      navigate("/driver-calendar");
      dispatch(
        updateUsers({
          key: "currentDriver",
          value: {
            id: item.driverId,
            hubId: item?.hubId,
          },
        }),
      );
      dispatch(
        updateUsers({
          key: "transferTimeoffModal",
          value: {
            visible: true,
            timeoffId: item.id,
            driverId: item.driverId,
          },
        }),
      );

      return;
    }

    try {
      await client.put(
        `${process.env.REACT_APP_API_URL}/drivers/approve-timeoff`,
        {
          id: item.id,
        },
      );
      dispatch(getTimeoffNotifications({ selectedHubs }));
    } catch (e) {
      console.log("Error approving:", e);
    }
  };

  const handleReject = async (timeoffId) => {
    try {
      await client.put(
        `${process.env.REACT_APP_API_URL}/drivers/reject-timeoff`,
        {
          id: timeoffId,
        },
      );
      dispatch(getTimeoffNotifications({ selectedHubs }));
    } catch (e) {
      console.log("Error rejecting timeoff: ", e);
    }
  };

  return (
    <Popover
      placement="bottom"
      open={timeoffNotificationPopupVisible}
      onOpenChange={(state) =>
        dispatch(
          updateHome({ key: "timeoffNotificationPopupVisible", value: state }),
        )
      }
      arrow={false}
      trigger="click"
      content={
        <div className="w-[460px] max-h-[600px]">
          <div className="flex items-center justify-between px-6 pt-6">
            <div>
              <h1 className="text-base font-medium text-new-black font-poppins">
                Time-off Requests
              </h1>
              <p className="mt-1 font-normal text-xs text-dark-gray font-aileron">
                View pending requests for selected hub station
              </p>
            </div>

            <CustomTooltip tooltipTitle="Clear Notifications">
              <CloseIcon
                className="w-5 h-5 cursor-pointer stroke-dark-grey-text"
                onClick={handleClearAll}
              />
            </CustomTooltip>
          </div>

          <div className="max-h-[400px] mt-2 overflow-y-scroll px-6">
            <FilterItem
              label="Hub Station"
              identifier="hub"
              contentData={hubs}
              onSelect={(key, value) => onSelect(key, value)}
              selectedValues={selectedHubs}
              className="max-h-[200px] overflow-y-scroll"
              btnClassName="bg-[#E6EDEE] text-[#085054] hover:bg-primary-20"
              enableSearch
            />
            <div className="mt-4 mb-6">
              {timeoffNotifications?.length > 0 ? (
                <>
                  {/* in order to show the notifications in reverse order */}
                  {timeoffNotifications
                    .slice()
                    .sort((a, b) => b.id - a.id)
                    .map((item) => (
                      <div className="mt-2">
                        <TimeoffCard
                          tripsCount={item?.tripsCount}
                          sessionsCount={item?.sessionsCount}
                          item={item}
                          handleReject={handleReject}
                          handleApprove={handleApprove}
                        />
                      </div>
                    ))}
                </>
              ) : (
                <EmptyState />
              )}
            </div>
          </div>
        </div>
      }
    >
      <button type="button">
        {timeoffShowNotificationDot ? (
          <TimeoffNotificationIconWithRedDot className="fill-none stroke-black" />
        ) : (
          <TimeoffNotificationIcon className="fill-none stroke-black" />
        )}
      </button>
    </Popover>
  );
};

export default TimeoffNotificationPopup;
